import { useMutation } from '@tanstack/react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api/src/common/queryFunction';

export const useUnzipPartFile: MutationFunction<
  never,
  {
    uuid: string;
    quoteId: number;
    bundledPackAndGos: string[];
  }
> = ({ query, requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation(
    ({ uuid, quoteId, bundledPackAndGos }) =>
      request<never>(`/parts/files/${uuid}/unzip`, {
        init: {
          method: 'POST',
          body: { quoteId, bundledPackAndGos },
        },
        query,
      }),
    queryOptions,
  );
};
